import { api } from "./api";

// Notice Api's
export const noticeList = async (addUrl = "") => {
  return await api.get(`notice/list?${addUrl}`);
};

export const noticeDetails = async (id) => {
  return await api.get(`notice/details?id=${id}`);
};

export const addNotice = async (data) => {
  return await api.post("notice/add", data);
};

export const updateNotice = async (data) => {
  return await api.post("notice/update", data);
};

export const updateNoticeStatus = async (data) => {
  return await api.post("notice/status", data);
};

export const deleteNotice = async (id) => {
  return await api.post("notice/delete", { id });
};
